import React, { useMemo } from 'react';
import { FuelProgressBar } from '@frete.com/fuel-react';
import { useAppContext } from '@/context';
import { Container, Step, StepCompleted, StepNames } from './styled';

const stepNames = ['Motorista', 'Veículo/Proprietário', 'Viagem', 'Gerenciadora de risco'];

export const FormSteps: React.FC = () => {
  const { state } = useAppContext();
  const formSteps = useMemo(() => ({ ...state.formSteps }), [state.formSteps]);

  const isCurrent = (index: number) => index + 1 === formSteps.current;
  const isCompleted = (index: number) => index + 1 < formSteps.current;

  return (
    <Container>
      <FuelProgressBar value={formSteps.percent} />
      <StepNames>
        {stepNames.map((item, index) => (
          <Step active={isCurrent(index)} key={item}>
            {isCompleted(index) && <StepCompleted size="tiny" name="one-check" />}
            <span>{item}</span>
          </Step>
        ))}
      </StepNames>
    </Container>
  );
};
